import classStyle from './Doc.module.scss';
import verified1 from '@src/assets/verified1.png';
import verified2 from '@src/assets/verified2.png';
import verified3 from '@src/assets/verified3.png';
import verified4 from '@src/assets/verified4.png';
import verified5 from '@src/assets/verified5.png';
import verified6 from '@src/assets/verified6.png';
import verified7 from '@src/assets/verified7.png';
import verified8 from '@src/assets/verified8.png';
import verified9 from '@src/assets/verified9.png';
import verified10 from '@src/assets/verified10.png';
import verified11 from '@src/assets/verified11.png';
import verified12 from '@src/assets/verified12.png';
import bind1 from '@src/assets/bind1.png';
import bind2 from '@src/assets/bind2.png';
import bind3 from '@src/assets/bind3.png';
import bind4 from '@src/assets/bind4.png';
import bind5 from '@src/assets/bind5.png';
import buy1 from '@src/assets/buy1.png';
import buy2 from '@src/assets/buy2.png';
import buy3 from '@src/assets/buy3.png';
import buy4 from '@src/assets/buy4.png';
import buy5 from '@src/assets/buy5.png';
import sell1 from '@src/assets/sell1.png';
import sell2 from '@src/assets/sell2.png';
import sell3 from '@src/assets/sell3.png';
import sell4 from '@src/assets/sell4.png';
import sell5 from '@src/assets/sell5.png';
import recharge1 from '@src/assets/recharge1.png';
import recharge2 from '@src/assets/recharge2.png';
import withdraw1 from '@src/assets/withdraw1.png';
import withdraw2 from '@src/assets/withdraw2.png';
import withdraw3 from '@src/assets/withdraw3.png';

export const docTypes = [
    {
        key: 'Verified',
        title: '如何身份认证',
        text: '免实名认证可做低额度交易！\n请根据您的资金需求，解锁更高身份认证层级，享无限额度',
        list: [
            {
                title: '第一步：实名认证',
                subTitle: '中额度交易',
                text: '①：首页-设置-分层认证-实名认证，\n选择【身份证】或【护照】上传正反面扫描件，\n填写相应信息，提交并开始验证，验证通过后，完成认证。',
                textHiglights: [],
                imgs: [
                    {
                        img: verified1,
                    },
                    {
                        img: verified2,
                    },
                    {
                        img: verified3,
                    },
                    {
                        img: verified4,
                    },
                ],
            },
            {
                title: '第二步：扫脸认证',
                subTitle: '高额度交易',
                text: '①：首页-设置-分层认证-扫脸认证，检查及了解扫脸事项， 能更快完成认证，开启摄像头权限后，点击【了解了，去认证】',
                textHiglights: [],
                imgs: [
                    {
                        img: verified5,
                    },
                    {
                        img: verified6,
                        className: classStyle.contentImgMin,
                    },
                ],
            },
            {
                title: '',
                subTitle: '',
                text: '②：进入扫脸程序，【同意，立即开始】',
                textHiglights: [],
                imgs: [
                    {
                        img: verified7,
                    },
                    {
                        img: verified8,
                    },
                ],
            },
            {
                title: '',
                subTitle: '',
                text: '③：开启摄像头权限，根据指示说明，完成扫脸认证的上传。',
                textHiglights: [],
                imgs: [
                    {
                        img: verified9,
                    },
                ],
            },
            {
                title: '',
                subTitle: '',
                text: '④：若未完成认证上传，返回钱包，也可重新认证。',
                textHiglights: [],
                imgs: [
                    {
                        img: verified10,
                    },
                ],
            },
            {
                title: '第三步：手持声明书认证',
                subTitle: '无限额度交易',
                text: '①：首页-设置-分层认证-手持声明书认证， 查看/下载声明书模板、手写声明书后手持声明书，根据拍照范本， 完成拍照，将手持声明',
                textHiglights: [],
                imgs: [
                    {
                        img: verified11,
                    },
                    {
                        img: verified12,
                    },
                ],
            },
        ],
    },
    {
        key: 'Bind',
        title: '如何绑定收款方式',
        text: '',
        list: [
            {
                title: '第一步：进入钱包首页，点击“设置”按钮，点击【收款方式】',
                subTitle: '',
                text: '',
                textHiglights: [],
                imgs: [
                    {
                        img: bind1,
                    },
                    {
                        img: bind2,
                    },
                ],
            },
            {
                title: '第二步：点击“添加收款方式”，\n选择点击“银行卡”/"支付宝"/"微信"',
                subTitle: '',
                text: '',
                textHiglights: [],
                imgs: [
                    {
                        img: bind3,
                    },
                    {
                        img: bind4,
                    },
                ],
            },
            {
                title: '',
                subTitle: '',
                text: '第三步：输入/上传相关信息，点击“确认”； 完成绑定',
                textHiglights: [],
                imgs: [
                    {
                        img: bind5,
                    },
                ],
            },
        ],
    },
    {
        key: 'Buy',
        title: '在【优币钱包】买币',
        text: '',
        list: [
            {
                title: '第一步：进入钱第一步：点击首页【OTC快捷交易】\n按钮进入页面，进行买币。',
                subTitle: '',
                text: '',
                textHiglights: [],
                imgs: [
                    {
                        img: buy1,
                    },
                ],
            },
            {
                title: '第二步：选择买币转账方式（可选银行卡，支付宝或微信）',
                subTitle: '',
                text: '',
                textHiglights: [],
                imgs: [
                    {
                        img: buy2,
                    },
                ],
            },
            {
                title: '',
                subTitle: '',
                text: '第三步：可选择按金额购买（单位: 人民币），\n也可按数量购买（单位: USDT)',
                textHiglights: [],
                imgs: [
                    {
                        img: buy3,
                    },
                    {
                        img: buy4,
                    },
                ],
            },
            {
                title: '',
                subTitle: '',
                text: '第四步：输入购买金额，点击“购买USDT”; \n转账成功，等待钱包到账',
                textHiglights: [],
                imgs: [
                    {
                        img: buy5,
                    },
                ],
            },
        ],
    },
    {
        key: 'Sell',
        title: '在【优币钱包】卖币',
        text: '',
        list: [
            {
                title: '第一步：点击首页【OTC快捷交易】按钮进入页面，进行卖币。',
                subTitle: '',
                text: '',
                textHiglights: [],
                imgs: [
                    {
                        img: sell1,
                    },
                ],
            },
            {
                title: '第二步：选择卖币转账方式（可选银行卡，支付宝或微信）',
                subTitle: '',
                text: '',
                textHiglights: [],
                imgs: [
                    {
                        img: sell2,
                    },
                ],
            },
            {
                title: '',
                subTitle: '',
                text: '第三步：可选择按金额购买（单位: 人民币），\n也可按数量购买（单位: USDT）',
                textHiglights: [],
                imgs: [
                    {
                        img: sell3,
                    },
                    {
                        img: sell4,
                    },
                ],
            },
            {
                title: '',
                subTitle: '',
                text: '第四步：输入卖币金额，点击贩售USDT; 等待到账',
                textHiglights: [],
                imgs: [
                    {
                        img: sell5,
                    },
                ],
            },
        ],
    },
    {
        key: 'Recharge',
        title: '在【优币钱包】充币',
        text: '',
        list: [
            {
                title: '第一步：点击首页“充币”按钮，进入【充币】页面。',
                subTitle: '',
                text: '',
                textHiglights: [],
                imgs: [
                    {
                        img: recharge1,
                    },
                ],
            },
            {
                title: '第二步：选择币种，用需要支付的钱包扫描获得的二维码，\n或复制获得的地址到需要支付的钱包中，为优币钱包充币。\n(部分币种请注意：使用的协议是否准确)',
                subTitle: '',
                titleHiglights: ['(部分币种请注意：使用的协议是否准确)'],
                text: '',
                textHiglights: [],
                imgs: [
                    {
                        img: recharge2,
                    },
                ],
            },
        ],
    },
    {
        key: 'Withdraw',
        title: '在【优币钱包】提币',
        text: '',
        list: [
            {
                title: '第一步：点击首页“充币”按钮，进入【充币】页面。',
                subTitle: '',
                text: '',
                textHiglights: [],
                imgs: [
                    {
                        img: withdraw1,
                    },
                ],
            },
            {
                title: '第二步：选择币种，复制粘贴/扫描二维码填入提币地址，\n输入提币数量，提交(部分币种请注意：使用的协议是否准确)； \n也可以：选择站内手机号、站内邮箱，\n输入优币钱包账号的手机号/邮箱\n（无旷工费且到账快）。',
                subTitle: '',
                titleHiglights: [
                    '(部分币种请注意：使用的协议是否准确)；',
                    '（无旷工费且到账快）。',
                ],
                text: '',
                textHiglights: [],
                imgs: [
                    {
                        img: withdraw2,
                    },
                    {
                        img: withdraw3,
                    },
                ],
            },
            {
                title: '第三步：二次验证完成后，成功提交提币，稍后即会完成提币。',
                subTitle: '',
                text: '',
                textHiglights: [],
                imgs: [],
            },
        ],
    },
];
